<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="mb-3">
            <router-link v-bind:to="'/aliado/info_basica/' + id_aliado" class="btn btn-orange rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>

            <br />
          </div>
          <div class="mt-2 mb-3">
            <h3 class="text-orange fw-bold">{{ aliado.nombre_aliado }}</h3>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Información secundaria</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Fase del aliado <small>(clasificación por tipo de aliado)</small></label>
                  <select v-model="alianza.id_tipo_alianza" class="form-control">
                    <option v-for="(
                          tipo_alianza, index_tipo_alianza
                        ) in tipos_alianza" v-bind:key="index_tipo_alianza"
                      v-bind:value="tipo_alianza.id_tipo_alianza">
                      {{ tipo_alianza.tipo_alianza }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Tipo de aliado <small>(clasificación por tipo de descuento)</small></label>
                  <select v-on:change="set_descuento" v-model="alianza.id_tipo_descuento" class="form-control" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    ">
                    <option v-for="(
                          tipo_descuento, index_tipo_descuento
                        ) in tipos_descuento" v-bind:key="index_tipo_descuento"
                      v-bind:value="tipo_descuento.id_tipo_descuento">
                      {{ tipo_descuento.tipo_descuento }}
                    </option>
                  </select>
                </div>

                <div class="col-lg-12 form-group" v-if="alianza.id_tipo_descuento != 1 && alianza.id_tipo_descuento != 2">
                  <label>Servicios <small>(se especifica el tipo de servicio que se prestara, ejemplo: 10% de descuento en
                      productos)</small></label>
                  <div v-if="alianza.servicios.length != 0">
                    <div v-for="(servicio, index_servicio) in alianza.servicios" v-bind:key="index_servicio">
                      <span>{{ index_servicio + 1 }}.</span>
                      <input v-model="servicio.servicio" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                        session.usuario.perfil != 0
                        " />
                      <div v-if="aliado.estado_aliado != -1" class="text-end">
                        <a v-on:click="quitar_servicio(index_servicio)" href="javascript:void(0)" class="text-danger">
                          <i class="bx bx-trash"></i> Quitar servicio
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="aliado.estado_aliado != -1" class="mt-3">
                    <a v-on:click="agregar_servicio" href="javascript:void(0)" class="text-orange">
                      <i class="bx bx-plus-circle"></i> Agregar servicio
                    </a>
                  </div>
                </div>

                <div class="col-lg-12 form-group">
                  <label>Porcentaje de descuento <small>(por defecto se pone por el tipo de aliado, pero en el caso de
                      premium o menos de 15% se debe poner manual)</small></label>
                  <input v-model="alianza.descuento" class="form-control" type="text" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Personal administrativo <small>(cantidad de personal del area administrativa)</small></label>
                  <input v-model="aliado.personal_admin" class="form-control" type="number" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Personal operativo <small>(cantidad de personal del area operativa)</small></label>
                  <input v-model="aliado.personal_operativo" class="form-control" type="number" :disabled="aliado.estado_aliado == 2 && session.usuario.perfil != 0
                    " />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Tipo de establecimiento <small>(se debe seleccionar un tipo de negocio entre virtual o
                      presencial)</small></label>
                  <select v-model="aliado.establecimiento" class="form-select mb-3">
                    <option selected>Selecciona tipo de establecimiento</option>
                    <option value="0">Presencial</option>
                    <option value="1">Virtual</option>
                  </select>
                </div>

                <!-- <div class="col-lg-12 form-group">
                  <label>Página</label>
                  <input
                    v-model="alianza.pagina"
                    class="form-control"
                    type="text"
                    :disabled="aliado.estado_aliado == 2 && session.usuario.perfil!=0"
                  />
                </div> -->
                <div class="col-lg-12 form-group">
                  <label class="mb-4">Sede de beneficios <small>(direccion donde se aplicaran los descuentos, por defecto
                      es la
                      principal, pero se pueden adicionar si el aliado tiene más sedes.)</small></label>
                  <div v-if="alianza.direcciones.length != 0">
                    <div class="row" v-for="(
                          direccion, index_direccion
                        ) in alianza.direcciones" v-bind:key="index_direccion">
                      <div class="col-lg-2">
                        <span v-if="index_direccion != 0" class="fw-bold mt-2">Nombre Sede{{ index_direccion + 1
                        }}.</span>
                        <span v-if="index_direccion == 0" class="fw-bold mt-2">Nombre Principal.</span>
                        <input v-if="index_direccion == 0" v-model="direccion.nombre" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                        <input v-if="index_direccion != 0" v-model="direccion.nombre" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                      </div>
                      <div class="col-lg-3">
                        <span v-if="index_direccion != 0" class="fw-bold mt-2">Dirección {{ index_direccion + 1 }}.</span>
                        <span v-if="index_direccion == 0" class="fw-bold mt-2">Dirección Principal.</span>
                        <input v-model="direccion.direccion" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                      </div>
                      <div class="col-lg-2">
                        <span v-if="index_direccion != 0" class="fw-bold mt-2">latitud {{ index_direccion + 1 }}.</span>
                        <span v-if="index_direccion == 0" class="fw-bold mt-2">latitud Principal.</span>
                        <input v-model="direccion.latitud" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                      </div>
                      <div class="col-lg-2">
                        <span v-if="index_direccion != 0" class="fw-bold mt-2">longitud {{ index_direccion + 1 }}.</span>
                        <span v-if="index_direccion == 0" class="fw-bold mt-2">longitud Principal.</span>
                        <input v-model="direccion.longitud" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                      </div>
                      <div class="col-lg-3">
                        <span v-if="index_direccion != 0" class="fw-bold mt-2">telefono / whatsapp {{ index_direccion + 1
                        }}.</span>
                        <span v-if="index_direccion == 0" class="fw-bold mt-2">telefono / whatsapp Principal.</span>
                        <input v-model="direccion.telefono" class="form-control" :disabled="aliado.estado_aliado == 2 &&
                          session.usuario.perfil != 0
                          " />
                      </div>
                      <div v-if="aliado.estado_aliado != -1" class="text-end">
                        <a v-if="index_direccion != 0" v-on:click="quitar_direccion(index_direccion)"
                          href="javascript:void(0)" class="text-danger">
                          <i class="bx bx-trash"></i> Quitar dirección
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="aliado.estado_aliado != -1" class="mt-3">
                    <a v-on:click="agregar_direccion" href="javascript:void(0)" class="text-orange">
                      <i class="bx bx-plus-circle"></i> Agregar dirección
                    </a>
                  </div>
                </div>

                <div class="col-lg-12 form-group">
                  <label>Descripción <small>(descripcion general de los servicios y descuentos, se visualiza en la app y
                      la pagina web)</small></label>
                  <textarea v-model="alianza.descripcion" class="form-control" rows="6"></textarea>
                </div>

              </div>
              <hr />
              <div class="mt-2 mb-2 text-end">
                <button v-on:click="update_aliado(1)" class="btn btn-orange btn-lg rounded-pill">
                  <i class="bx bx-save"></i> Guardar y finalizar
                </button>
                <button v-on:click="update_aliado(2)" class="btn btn-success btn-lg rounded-pill ms-1">
                  <i class="bx bx-save"></i> Guardar y continuar
                  <i class="bx bx-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <router-link v-bind:to="'/aliado/info_basica/' + id_aliado" class="btn btn-outline-secondary rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>

            <br />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Aliado_info_basica",
  metaInfo: {
    title: "Aliados - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      tipos_alianza: [],
      tipos_descuento: [],
      id_aliado: null,
      aliado: [],
      alianza: {
        id_alianza: null,
        id_tipo_alianza: null,
        id_tipo_descuento: null,
        descuento: 0,
        tamano_pieza: null,
        pagina: null,
        direccion_beneficios: null,
        servicios: [],
        descripcion: null,
      },
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
    this.get_tipos_alianzas();
    this.get_tipos_descuento();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          if (this.aliado.alianza != null) {
            this.alianza = this.aliado.alianza;
          }
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_tipos_alianzas: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/tipos_alianzas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.tipos_alianza = response.data.data.tipos_alianzas;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_tipos_descuento: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/tipos_descuentos", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.tipos_descuento = response.data.data.tipos_descuento;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    update_aliado: function (step) {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        aliado: this.aliado,
      };
      axios
        .post(this.$base_url + "aliados/update_aliado", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          }
          vm.update_alianza(step);
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    update_alianza: function (step) {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_aliado: this.id_aliado,
        alianza: this.alianza,
      };
      axios
        .post(this.$base_url + "aliados/update_alianza", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente!",
              text: response.data.message,
            });
          }
          switch (step) {
            case 1:
              vm.$router.push("/aliado/info_basica/" + vm.id_aliado);
              break;
            case 2:
              vm.$router.push("/aliado/contrato/" + vm.id_aliado);
              break;
          }
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    agregar_servicio: function () {
      this.alianza.servicios.push({
        id_servicio_alianza: null,
        servicio: null,
      });
    },
    quitar_servicio: function (index_servicio) {
      this.alianza.servicios.splice(index_servicio, 1);
    },
    agregar_direccion: function () {
      this.alianza.direcciones.push({
        id_direccion_beneficios: null,
        nombre: null,
        direccion: null,
        lng: null,
        lat: null,
        telefono: null
      });
    },
    quitar_direccion: function (index_direccion) {
      this.alianza.direcciones.splice(index_direccion, 1);
    },
    set_descuento: function () {
      const tipo_descuento = this.tipos_descuento.find(tipo_descuento => tipo_descuento.id_tipo_descuento === this.alianza.id_tipo_descuento);
      this.alianza.descuento = tipo_descuento.descuento;
    }
  },
};
</script>